const CHAIN_KEY = "selectedChainId";
const TOKEN_KEY = "selectedTokenId";

function read(storage, key) {
  try {
    return storage.getItem(key);
  } catch {
    return null;
  }
}

function write(storage, key, value) {
  try {
    if (value) storage.setItem(key, value);
    else storage.removeItem(key);
  } catch {
    /* quota / private mode */
  }
}

/** Last chain the user picked in the app. Survives refresh. */
export function getSavedChainId() {
  return read(localStorage, CHAIN_KEY) || read(sessionStorage, CHAIN_KEY);
}

export function getSavedTokenId() {
  return read(localStorage, TOKEN_KEY) || read(sessionStorage, TOKEN_KEY);
}

export function setSavedChainId(chainId) {
  write(localStorage, CHAIN_KEY, chainId || null);
  write(sessionStorage, CHAIN_KEY, chainId || null);
}

export function setSavedTokenId(tokenId) {
  write(localStorage, TOKEN_KEY, tokenId || null);
  write(sessionStorage, TOKEN_KEY, tokenId || null);
}
